'use client';

import Slider from 'rc-slider';

import 'rc-slider/assets/index.css';

import { useClientSmallScreen } from '@/lib/user-agent/client';

import { pageLevelLocalization } from '@/constant/localization';

import Mark, { markStyle } from './mark';
import { historyYears } from '../../services/type';

const {
  content: {
    aboutUs: { history: historyLocalization },
  },
} = pageLevelLocalization;

const marks = {
  0: '',
  [historyYears[1393]]: {
    style: markStyle,
    label: <Mark year={1393} title={historyLocalization.first_spark} />,
  },
  [historyYears[1395]]: {
    style: markStyle,
    label: <Mark year={1395} title={historyLocalization.establishment} />,
  },
  [historyYears[1398]]: {
    style: markStyle,
    label: <Mark year={1398} title={historyLocalization.firstVersion} />,
  },
  [historyYears[1402]]: {
    style: markStyle,
    label: <Mark year={1402} title={historyLocalization.changeBlogUI} />,
  },
  [historyYears[1403]]: {
    style: markStyle,
    label: <Mark isLastOne year={1403} title={historyLocalization.new_site} />,
  },
};
type HistorySliderProps = {
  onChange: (key: number | number[]) => void;
};
export default function HistorySlider({ onChange }: HistorySliderProps) {
  const isMobile = useClientSmallScreen();

  return (
    <Slider
      marks={marks}
      allowCross={false}
      min={0}
      max={48}
      step={null}
      vertical={!!isMobile}
      onChange={onChange}
      defaultValue={40}
      styles={{
        handle: {
          background: '#FFC107',
          border: '3px solid white',
          width: '18px',
          height: '18px',
          marginRight: isMobile ? '-6px' : '0',
        },
        rail: {
          background: '#F7F8F9',
          height: !isMobile ? `8px` : '100%',
          minWidth: '8px',
        },
        track: {
          backgroundImage: 'linear-gradient(to left,#FFC107,#FF9737)',
          minHeight: !isMobile ? `8px` : 'auto',
          boxShadow: '0px 6px 15px -3px rgba(255, 171, 34, 1);',
          minWidth: '8px',
        },
        tracks: {},
      }}
      dotStyle={{
        background: '#C1C3C8',
        width: '18px',
        height: '18px',
        border: '3px solid white',
        marginBottom: isMobile ? '0' : '-6px',
        marginRight: isMobile ? '-6px' : '0',
      }}
      activeDotStyle={{
        background: '#C1C3C8',
        width: '18px',
        height: '18px',
        border: '3px solid white',
      }}
      style={{ position: 'relative', height: 'auto', minWidth: '18px' }}
    />
  );
}
